import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import {
  AlunoEnvolvido,
  ListarChamados,
  FuncionarioEnvolvido,
} from 'src/app/shared/models/chamados/listar-chamados';
import { FormGroup } from '@angular/forms';

export class ChamadoFiltro extends FiltroPadrao {
  nomeAluno?: string;
  raAluno?: number;
  codigoChamado?: number;
  codigoStatus?: number;
  cpfEquipeEscolar?: string;

  pagina = 1;
  paginaSize = 5;
  totalRegisterCount = 0;

  gravidades = [
    { id: 1, name: 'Amarelo' },
    { id: 2, name: 'Vermelho' },
  ];

  status = [
    {
      id: 0,
      name: 'Não Analisado',
      variants: ['Pendente análise do chamado'],
    },
    {
      id: 1,
      name: 'Encaminhado ao Psicólogo',
      variants: ['Atrasado Agendamento do Psicólogo'],
    },
    {
      id: 2,
      name: 'Encaminhado a Rede Protetiva',
      variants: ['Atrasado Atendimento da Rede Protetiva'],
    },
    {
      id: 3,
      name: 'Encaminhado a Saúde',
      variants: ['Encaminhado ao Hospital', 'Atrasado Atendimento da Saúde'],
    },
    {
      id: 4,
      name: 'Psicólogo Agendado',
      variants: ['Aguardando Atendimento do Psicólogo'],
    },
    {
      id: 5,
      name: 'Atendimento Realizado',
      variants: ['Aguardando Encerramento'],
    },
    {
      id: 6,
      name: 'Encerrado',
      variants: ['Concluido'],
    },
  ];

  constructor(init?: Partial<ChamadoFiltro>) {
    super();
    // aceita receber valores vindos do FiltroService (signal) ou do Form
    if (init) {
      Object.assign(this, init as Partial<ChamadoFiltro>);

      // normalizações simples
      if ((this.raAluno as any) && typeof this.raAluno !== 'number') {
        const n = Number((this.raAluno as any).toString().replace(/\D+/g, ''));
        this.raAluno = Number.isFinite(n) ? n : undefined;
      }

      if (
        (this.codigoChamado as any) &&
        typeof this.codigoChamado !== 'number'
      ) {
        const n = Number(
          (this.codigoChamado as any).toString().replace(/\D+/g, ''),
        );
        this.codigoChamado = Number.isFinite(n) ? n : undefined;
      }

      if ((this.codigoStatus as any) && typeof this.codigoStatus !== 'number') {
        const n = Number(
          (this.codigoStatus as any).toString().replace(/\D+/g, ''),
        );
        this.codigoStatus = Number.isFinite(n) ? n : undefined;
      }

      if ((this.pagina as any) && typeof this.pagina !== 'number') {
        const n = Number(this.pagina);
        this.pagina = Number.isFinite(n) ? n : 1;
      }

      if ((this.paginaSize as any) && typeof this.paginaSize !== 'number') {
        const n = Number(this.paginaSize);
        this.paginaSize = Number.isFinite(n) ? n : 5;
      }
    }

    this.pagina = this.pagina ?? 1;
    this.paginaSize = this.paginaSize ?? 5;
  }

  toApiParams(): ListarChamados {
    const dto = new ListarChamados();

    // Campos de localização / filtro já existentes em FiltroPadrao
    dto.codigoDiretoria = this.codigoDiretoria ?? 0;
    dto.codigoEscola = this.codigoEscola ?? 0;
    dto.codigoTurno = this.codigoTurno ?? undefined;
    dto.codigoTurma = this.codigoTurma ?? undefined;
    dto.codigoGravidade = this.codigoGravidade ?? undefined;
    dto.anoAtual = this.anoAtual ?? undefined;

    // Paginação
    dto.pagina = this.pagina ?? 1;

    // Código do chamado
    dto.codigoChamado =
      this.codigoChamado != null ? Number(this.codigoChamado) : 0;

    // Status / filtro de status
    if (this.codigoStatus != null)
      dto.filtroStatusEnvolvido = Number(this.codigoStatus);

    // Se temos nome/ra do aluno, preencher bloco aluno (tipoPessoa = 1)
    if (this.nomeAluno || this.raAluno) {
      dto.tipoPessoa = 1;
      dto.aluno = new AlunoEnvolvido();
      dto.aluno.nomeAluno = this.nomeAluno ?? undefined;
      if (this.raAluno != null) dto.aluno.ra = String(this.raAluno);
    }

    // cpf equipe escolar -> tipoPessoa 2
    if ((this as any).cpfEquipeEscolar) {
      dto.tipoPessoa = 2;
      dto.equipeEscolar = new FuncionarioEnvolvido();
      dto.equipeEscolar.cpf = (this as any).cpfEquipeEscolar;
    }

    return dto;
  }

  /**
   * Método utilitário que gera o DTO `ListarChamados` (compatível com o serviço)
   * Pode ser usado quando precisar priorizar valores do form, informar id do chamado
   * ou sobrescrever a página atual.
   */
  toListarChamados(
    form?: FormGroup,
    parametroIdChamado?: number,
    page?: number,
  ): ListarChamados {
    // prioriza valores do form quando fornecido
    const source: any = form ? { ...this, ...form.value } : this;
    const dto = new ListarChamados();

    dto.codigoDiretoria = source.codigoDiretoria ?? 0;
    dto.codigoEscola = source.codigoEscola ?? 0;
    dto.codigoTurno = source.codigoTurno ?? undefined;
    dto.codigoTurma = source.codigoTurma ?? undefined;
    dto.codigoGravidade = source.codigoGravidade ?? undefined;
    dto.anoAtual = source.anoAtual ?? undefined;

    dto.pagina = page ?? source.pagina ?? 1;
    dto.codigoChamado = source.codigoChamado ?? parametroIdChamado ?? 0;

    if (source.codigoStatus != null)
      dto.filtroStatusEnvolvido = Number(source.codigoStatus);

    dto.ordenacaoCrescente = source.ordenacaoCrescente ?? true;
    dto.semEnvolvido = source.semEnvolvido ?? false;

    if (source.nomeAluno || source.raAluno) {
      dto.tipoPessoa = 1;
      dto.aluno = new AlunoEnvolvido();
      if (source.nomeAluno) dto.aluno.nomeAluno = source.nomeAluno;
      if (source.raAluno != null) dto.aluno.ra = String(source.raAluno);
    } else if ((source as any).cpfEquipeEscolar) {
      dto.tipoPessoa = 2;
      dto.equipeEscolar = new FuncionarioEnvolvido();
      dto.equipeEscolar.cpf = (source as any).cpfEquipeEscolar;
    }

    return dto;
  }
}
